/**
 * Provider dell'alberatura: la carica una volta e la tiene a disposizione di
 * tutte le pagine protette.
 */

import { useCallback, useMemo } from "react";
import type { ReactNode } from "react";
import { leggiAlberatura } from "../api/client";
import { useAutenticazione } from "../auth/contesto";
import { appiattisciAlberatura } from "../lib/scadenze";
import { useRisorsa } from "../lib/useRisorsa";
import { ContestoAlberatura } from "./contesto-alberatura";
import type { ValoreAlberatura } from "./contesto-alberatura";

export function FornitoreAlberatura({ children }: { children: ReactNode }) {
  const { utente } = useAutenticazione();
  const enteId = utente?.ente_id ?? null;

  const carica = useCallback(
    (segnale: AbortSignal) => leggiAlberatura(enteId, segnale),
    [enteId],
  );
  const { dato, inCaricamento, errore, ricarica } = useRisorsa(carica, [enteId]);

  const valore = useMemo<ValoreAlberatura>(() => {
    const nodi = dato?.nodi ?? [];
    const tuttiINodi = appiattisciAlberatura(nodi);
    const perId = new Map(tuttiINodi.map((nodo) => [nodo.id_nodo, nodo]));
    return {
      ente: dato?.ente ?? null,
      nodi,
      tuttiINodi,
      inCaricamento,
      errore,
      ricarica,
      denominazione: (idNodo) => perId.get(idNodo)?.denominazione ?? idNodo,
    };
  }, [dato, inCaricamento, errore, ricarica]);

  return <ContestoAlberatura.Provider value={valore}>{children}</ContestoAlberatura.Provider>;
}
